export enum DoctorType {
    PrimaryDoctor = 1,
    VisitDoctor = 2,
}
